import { Box, Stack } from "@mui/system";
import { RadialBarChart, RadialBar, Tooltip, Legend } from "recharts";
import { LineChart } from "@mui/x-charts/LineChart";
// import { BarChart } from "@mui/x-charts/BarChart";
// import { getDatabase, ref, set, update, onValue } from "firebase/database";
// import firebaseApp from "./firebaseConfig";
import { useEffect, useState } from "react";
import axios from "../../../../../api/axios";
import { Alert, Typography } from "@mui/material";

const AssetManagementTab = () => {
  // const database = getDatabase(firebaseApp);
  const pid = "3093";
  // const databaseRef = ref(database, `/valves/${pid}/`);
  const [temp, setTemp] = useState(0);
  const [pres, setPres] = useState(0);
  const [tempData, setTempData] = useState([]);
  const [presData, setPresData] = useState([]);
  const [initialState, setInitialState] = useState(true);

  const temps = [
    ,
    {
      name: "PV2 Temp",
      temp: 60,
      fill: "#83a6ed",
    },
    {
      name: "PV3 Temp",
      temp: 75,
      fill: "#8dd1e1",
    },
    {
      name: "PV4 Temp",
      temp: 90,
      fill: "#82ca9d",
    },
    {
      name: "PV1 Temp",
      temp: temp,
      fill: "#8884d8",
    },
  ];

  const preses = [
    ,
    {
      name: "PV2 pres",
      pres: 40,
      fill: "#83a6ed",
    },
    {
      name: "PV3 pres",
      pres: 55,
      fill: "#8dd1e1",
    },
    {
      name: "PV4 pres",
      pres: 80,
      fill: "#82ca9d",
    },
    {
      name: "PV1 pres",
      pres: pres,
      fill: "#8884d8",
    },
  ];

  const getChartdata = async () => {
    const res = await axios.get("/pressure_vessel/realtime");
    setTempData(res.data.reverse().map((d) => d.temp));
    setPresData(res.data.reverse().map((d) => d.pres));
    console.log("heree");
    console.log(res);
  };

  // useEffect(() => {
  //   onValue(
  //     databaseRef,
  //     async (sanpShot) => {
  //       console.log(sanpShot.val());
  //       setTemp(sanpShot.val().temp);
  //       setPres(sanpShot.val().pres);
  //       if (!initialState) {
  //         const res = await axios.post("/pressure_vessel/realtime", {
  //           temp,
  //           pres,
  //         });
  //         setTempData((prev) => [...prev, temp]);
  //         setPresData((prev) => [...prev, pres]);
  //         console.log(tempData);
  //       } else {
  //         await getChartdata();
  //         setInitialState(false);
  //       }
  //     },
  //     { onlyOnce: false }
  //   );
  //   getChartdata();
  // }, []);
  //   onValue(
  //     databaseRef,
  //     (sanpShot) => {
  //       console.log(sanpShot.val());
  //     },
  //     { onlyOnce: false }
  //   );

  useEffect(() => {
    // getChartdata();

    const interval = setInterval(async () => {
      const newTemp = Math.floor(Math.random() * 50) + 50; // 50-100
      const newPres = Math.floor(Math.random() * 50) + 30; // 30-80
      setTemp(newTemp);
      setPres(newPres);

      // await axios.post("/pressure_vessel/realtime", {
      //   temp: newTemp,
      //   pres: newPres,
      // });

      setTempData((prev) => [...prev.slice(-19), newTemp]); // keep last 20
      setPresData((prev) => [...prev.slice(-19), newPres]); // keep last 20
    }, 3000); // simulate every 3s

    return () => clearInterval(interval);
  }, []);

  return (
    <Box sx={{ width: "100%", typography: "body1", overflow: "auto" }}>
      {/* The readings below are generated every 3s (see the interval above)
          until the historian feed is connected - say so on screen. */}
      <Alert severity="info" sx={{ mb: 2 }}>
        Simulated readings - temperature and pressure are generated for
        demonstration and do not come from the plant's historian yet.
      </Alert>
      <Box sx={{ display: "flex", flexWrap: "wrap" }}>
        <Stack alignItems={"center"}>
          <Typography variant="h5" color="secondary">
            Temperature Transmitter
          </Typography>
          <RadialBarChart
            width={500}
            height={350}
            innerRadius="10%"
            outerRadius="80%"
            data={temps}
            startAngle={180}
            endAngle={0}
          >
            <RadialBar
              minAngle={0}
              label={{ fill: "#666", position: "insideStart" }}
              background
              clockWise={true}
              dataKey="temp"
            />
            <Legend
              iconSize={10}
              width={120}
              height={140}
              layout="vertical"
              verticalAlign="middle"
              align="right"
            />
            <Tooltip />
          </RadialBarChart>
        </Stack>
        {tempData ? (
          <LineChart
            // xAxis={[{ data: data.map((d) => d.createdAt) }]}
            series={[
              {
                curve: "linear",
                data: tempData,
                label: "Temperature",
              },
              {
                curve: "linear",
                data: presData,
                label: "Pressure",
              },
            ]}
            width={500}
            height={300}
          />
        ) : (
          <></>
        )}
      </Box>

      <Stack width={"min-content"} alignItems={"center"}>
        <Typography variant="h5" color="secondary">
          Pressure Transmitter
        </Typography>
        <RadialBarChart
          width={500}
          height={350}
          innerRadius="10%"
          outerRadius="80%"
          data={preses}
          startAngle={180}
          endAngle={0}
        >
          <RadialBar
            minAngle={0}
            label={{ fill: "#666", position: "insideStart" }}
            background
            clockWise={true}
            dataKey="pres"
          />
          <Legend
            iconSize={10}
            width={120}
            height={140}
            layout="vertical"
            verticalAlign="middle"
            align="right"
          />
          <Tooltip />
        </RadialBarChart>
      </Stack>
    </Box>
  );
};

export default AssetManagementTab;
